/**
 * Обработка команды бросания кубиков
 */
class DiceCommand
{
    /**
     * ВАлидная команда
     * @param command
     * @returns {boolean}
     */
   isValidCommand(command)
   {
       if (command.match(/^\/(((d|д)(?![0]$)\d+)(\s+)?)+(u(\s+)?)?$/ui)) {
           return true;
       }
       return false;
   }

    /**
     * Тело команды
     */
    getCommandBody(message)
    {
        return message.substring(1);
    }

    /**
     * Массив размеров кубиков
     * @param commandBody
     * @returns {[]}
     */
    getDiceSizes(commandBody)
    {
        const diceTypesArray = ['4', '6', '8', '10', '12', '20', '100'];
        const diceSizesString = commandBody.replace(/d|д/g, '');
        const diceSizes = diceSizesString.split(' ');
        let result = [];
        diceSizes.forEach((size) => {
            if (diceTypesArray.includes(size)) {
                result.push(size);
            }
        });

        return result;
    }

    /**
     * Трасформирует набор значений кубиков к реальным кубикам
     * Разбивает d100 на два кубика d100 с десятками и d10 с единицами
     * @param values
     * @returns {[]}
     */
    transformValuesForRealDices(values)
    {
        let result = [];
        values.forEach((item) => {
            if (item.type === 'd100') {
                let d10Value = item.value % 10;
                result.push({
                    value: d10Value,
                    type: 'd10',
                });

                const d100Value = item.value - d10Value;
                result.push({
                    value: d100Value > 0 ? d100Value / 10 : 0,
                    type: 'd100',
                });
            } else {
                result.push(item);
            }
        });

        return result;
    }
}

export default new DiceCommand();
